'use strict';

var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var Chip = require('../Chip/Chip.js');
var StatusDot = require('../../../IconsAndImages/Icons/StatusDot.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var COLOR_RED = 'red';
var COLOR_ORANGE = 'orange';
var COLOR_GREEN = 'green';
var COLOR_BLUE = 'blue';
var COLOR_GREY = 'grey';
var COLOR_LIGHT_BLUE = 'lightBlue';
var COLOR_DARK_GREEN = 'darkGreen';

var styles = function styles(theme) {
  return {
    chip: {
      border: '0px',
      height: 24
    },
    icon: {
      marginLeft: -6
    },
    label: {
      paddingRight: 0
    },
    redColor: {
      color: theme.palette.error.main
    },
    orangeColor: {
      color: theme.palette.alert.main
    },
    greenColor: {
      color: theme.palette.success.main
    },
    blueColor: {
      color: theme.palette.primary.main
    },
    greyColor: {
      color: 'rgba(0, 0, 0, 0.12)'
    },
    lightBlueColor: {
      color: theme.palette.primary.light
    },
    darkGreenColor: {
      color: theme.palette.success.dark
    }
  };
};

var colorFromStatusForBackwardCompatibility = function colorFromStatusForBackwardCompatibility(status) {
  if (status === 'Active') {
    return COLOR_GREEN;
  } else if (status === 'Draft') {
    return COLOR_GREY;
  } else if (status === 'Pending') {
    return COLOR_BLUE;
  } else if (status === 'Expired') {
    return COLOR_RED;
  } else if (status === 'Expiring soon') {
    return COLOR_ORANGE;
  } else if (status == 'Pending renewal') {
    return COLOR_LIGHT_BLUE;
  } else if (status == 'Renewed') {
    return COLOR_DARK_GREEN;
  }
};

var StatusDisplay = function StatusDisplay(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      color = _ref.color,
      status = _ref.status;
  return React__default["default"].createElement(Chip, {
    variant: "outlined",
    icon: React__default["default"].createElement(StatusDot, {
      className: classes["".concat(color || colorFromStatusForBackwardCompatibility(status), "Color")]
    }),
    label: label || status,
    classes: {
      root: classes.chip,
      icon: classes.icon,
      label: classes.label
    }
  });
};

var StatusDisplay$1 = withStyles["default"](styles)(StatusDisplay);

module.exports = StatusDisplay$1;
